import { type FC } from 'react'
import { Button } from '../../../../components/Button/Button'
import { EmailCanvas, EmailPreviewCard } from './EmailPreviewCard'
import { type RenderedPreview } from './preview/renderPreview'

export interface EmailPreviewProps {
  rendered: RenderedPreview | null
  fromName: string
  hasIssues: boolean
  onEdit: () => void
}

export const EmailPreview: FC<EmailPreviewProps> = ({ rendered, fromName, hasIssues, onEdit }) =>
  rendered !== null && rendered.error === null ? (
    <EmailPreviewCard fromName={fromName} subject={rendered.subject} body={rendered.body} />
  ) : (
    <EmailCanvas>
      <div role='status' className='d-flex flex-column align-items-center gap-1 py-5 px-3 text-center'>
        <p className='m-0 heading-small zocks-text-gray-900'>Preview isn&apos;t available right now</p>
        <p className='m-0 paragraph-medium fw-normal zocks-text-gray-600'>
          {hasIssues ? 'Fix the issues in the editor to see the preview.' : 'Something went wrong. Your changes are safe.'}
        </p>
        <Button variant='darkGhost' className='mt-3' onClick={onEdit}>
          Back to editing
        </Button>
      </div>
    </EmailCanvas>
  )
